export default "__VITE_ASSET__D3rzXh2H__"